export const kidsOptions = ["Yes", "No", "Prefer not to say"];
